import { CloseButton, Modal } from 'react-bootstrap';

type Props = { file: string; onClose: () => void; title: string };
export const FileModal = (props: Props) => {
  const { file, onClose, title } = props;
  return (
    <Modal backdrop="static" closeBtn show={!!file} onHide={onClose} size="xl">
      <div style={{ position: 'absolute', right: '-45pt', top: '-10pt' }}>
        <CloseButton style={{ fontSize: '4rem', color: 'red' }} onClick={onClose} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <iframe src={file} title={title} width="100%" height={600} />
      </div>
    </Modal>
  );
};
